// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.description[data-v-7d77f576] {\n  color: #fff;\n  font-size: 1.25rem;\n  margin-top: 1rem;\n  margin-bottom: 0;\n}\n.content[data-v-7d77f576] {\n  margin-top: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
